import {executor} from "./js-to-string";

const regExp = /{(.*)}/ms;

export function getScriptFromBraces(script) {
    return script.match(regExp)?.[1];
}

/**
 *
 * @param js
 * @param globalValues
 * @param screenName
 * @param actions
 * @returns {null|any}
 */
export default async function getSingleParamFromJs(js, globalValues, screenName, actions) {
    let truncatedBraces = getScriptFromBraces(js);
    if (truncatedBraces) {
        return await executor(truncatedBraces, globalValues, screenName, actions)
    }
    return null;
}